import cabanaRiverside from "@/assets/cabanas/cabana-riverside.jpg";
import cabanaRiverView from "@/assets/cabanas/cabana-river-view.jpg";
import cabanasMultiple from "@/assets/cabanas/cabanas-multiple.jpg";
import cabanasRiverStairs from "@/assets/cabanas/cabanas-river-stairs.jpg";
import cabanaGrillSeating from "@/assets/cabanas/cabana-grill-seating.jpg";
import familyTubes from "@/assets/tubing/family-tubes.jpg";
import friendsFloatingCooler from "@/assets/tubing/friends-floating-cooler.jpg";
import sonsTubesStacked from "@/assets/tubing/sons-tubes-stacked.jpg";
import groupTubingFun from "@/assets/tubing/group-tubing-fun.webp";
import riverHangout from "@/assets/gallery/river-hangout.jpg";
import clearRiver from "@/assets/gallery/clear-river.jpg";
import aerialCabanas from "@/assets/gallery/aerial-cabanas.jpg";

export interface PopupImage {
  id: string;
  label: string;
  group: string;
  src: string;
}

export const POPUP_IMAGES: PopupImage[] = [
  { id: "cabana-riverside", label: "Riverside cabana", group: "Cabanas", src: cabanaRiverside },
  { id: "cabana-river-view", label: "Cabana river view", group: "Cabanas", src: cabanaRiverView },
  { id: "cabanas-multiple", label: "Row of cabanas", group: "Cabanas", src: cabanasMultiple },
  { id: "cabanas-river-stairs", label: "Cabanas by river stairs", group: "Cabanas", src: cabanasRiverStairs },
  { id: "cabana-grill-seating", label: "Cabana grill & seating", group: "Cabanas", src: cabanaGrillSeating },
  { id: "family-tubes", label: "Family tubing", group: "Tubing", src: familyTubes },
  { id: "friends-floating-cooler", label: "Friends floating with cooler", group: "Tubing", src: friendsFloatingCooler },
  { id: "sons-tubes-stacked", label: "Stacked tubes", group: "Tubing", src: sonsTubesStacked },
  { id: "group-tubing-fun", label: "Group tubing", group: "Tubing", src: groupTubingFun },
  { id: "river-hangout", label: "River hangout", group: "River", src: riverHangout },
  { id: "clear-river", label: "Clear river water", group: "River", src: clearRiver },
  { id: "aerial-cabanas", label: "Aerial of cabanas", group: "River", src: aerialCabanas },
];

export function getPopupImage(id: string): PopupImage {
  return POPUP_IMAGES.find((i) => i.id === id) ?? POPUP_IMAGES[0];
}
